var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { FieldType } from '../../../redux/questionnaire/typings';
import MessageBox from 'syf-component-library/ui/patterns/MessageBox';
import { Inset } from 'syf-component-library/ui/spacing';
import { Body } from 'syf-component-library/ui/typography';
import { QuestionErrorContainer } from '../../../pages/Questionnaire/subcomponents/Question/subcomponents';
import Icon from '../Icon';
var ErrorMessage = forwardRef(function (_a, ref) {
    var _b;
    var currentQuestion = _a.currentQuestion, formError = _a.formError;
    var fieldType = (_b = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.answers[0]) === null || _b === void 0 ? void 0 : _b.fieldType;
    if (!formError) {
        return null;
    }
    if (fieldType === FieldType.Radio ||
        fieldType === FieldType.Chips ||
        fieldType === FieldType.TableList) {
        return (_jsx(QuestionErrorContainer, { children: _jsx(Inset, __assign({ bottom: "base" }, { children: _jsx(MessageBox, __assign({ type: "error", icon: _jsx(Icon, { name: "faExclamationCircle", size: "lg" }), ref: ref, tabIndex: -1 }, { children: _jsx(Body, { children: formError }) })) })) }));
    }
    return null;
});
export default ErrorMessage;
//# sourceMappingURL=index.js.map